import NavBar from '@/components/Nav.vue';

import functions from '@/functions.js';

export default {
    name: 'ActivityDetailPage',
    components: {
        NavBar,
    },
    data() {
        return {
            trackRuning: false,
            trackLeft: 0,
            trackGroup: 34,
            trackConfig: {width: 0, crevice: 0, endLeft: 0, prize: {}, showPrize: false},
            tabType: 'rule',
            dateFormat: functions.dateFormat,
            notices: [],
            noticeIndex: 0,
            noticeTimer: null,
            activity: null,
            hexToRgb: functions.hexToRgb
        }
    },
    created() {
        this.$http.get('activity/' + this.$route.params.id, {params: {token: this.$route.query.token}}).then(result => {
            let grands = [];
            for (let index = 0; index < result.data.activity.grands.length; index += 2) {
                let temp = [];
                temp.push(result.data.activity.grands[index]);
                if (typeof result.data.activity.grands[index + 1] != 'undefined') {
                    temp.push(result.data.activity.grands[index + 1]);
                }
                grands.push(temp);
            }
            result.data.activity.grands = grands;
            this.activity = result.data.activity;
            // 设置中奖公告轮播
            this.notices = result.data.notices;
            if (this.notices.length) {
                this.noticeTimer = setInterval(() => {
                    this.noticeIndex = this.noticeIndex + 1 == this.notices.length ? 0 : this.noticeIndex + 1;
                }, 3000);
            }
            // 判断生成的分组数量，至少形成一个闭环
            let trackGroup = Math.ceil(50 / this.activity.prizes.length);
            this.trackGroup = trackGroup > 4 ? trackGroup : 4;
        })
    },
    unmounted() {
        clearInterval(this.noticeTimer);
    },
    methods: {
        jump() {
            if (this.trackConfig.entityKey) {
                this.$router.push('/entity');
            } else {
                this.$router.push('/welfare');
            }
        },
        luckdraw() {
            let now = Date.parse(new Date);
            if (now < Date.parse(this.activity.start_time) || now > Date.parse(this.activity.end_time)) {
                this.$toast('活动暂未开启');
            } else if (! this.trackRuning) {
                if (this.activity.number) {
                    this.$http.post('activity/' + this.$route.params.id).then(result => {
                        this.trackConfig.entityKey = result.data.entity_id;
                        this.trackConfig.welfareKey = result.data.welfare_id;
                        this.activity.number--;
                        this.trackRuning = true;
                        this.setEndConfig(result.data.prize_id);
                        if (result.data.prize_id) {
                            this.appendRecord = result.data.record;
                        }
                        this.move(200);
                    });
                } else {
                    this.$toast('抽奖次数不足');
                }
            }
        },
        move(time) {
            setTimeout(() => {
                let tempLeft = this.trackLeft + this.trackConfig.endLeft / 500;
                let node = this.trackConfig.endLeft * 0.95;
                if (tempLeft < node) {
                    this.move(time > 10 ? time - 10 : 10);
                } else {
                    if (tempLeft >= this.trackConfig.endLeft) {
                        tempLeft = this.trackConfig.endLeft;
                    } else {
                        this.move(time < 200 ? time + 10 : 200);
                    }
                }
                this.trackLeft = tempLeft;
                if (tempLeft >= this.trackConfig.endLeft) {
                    this.moveEnd();
                }
            }, time);
        },
        moveEnd() {
            this.trackRuning = false;
            if (this.trackConfig.prizeKey) {
                this.trackConfig.showPrize = true;
                this.activity.records.unshift(this.appendRecord);
            } else {
                this.$toast('很遗憾，未中奖');
            }
        },
        setEndConfig(prizeKey) {
            this.trackLeft = 0;
            this.trackConfig.prizeKey = prizeKey;
            // 判断最后停留的组数
            let endGroup = this.activity.prizes.length >= 4 ? this.trackGroup - 2 : this.trackGroup - Math.ceil(4 / this.activity.prizes.length) * 2;
            // 获得最后的下标
            let endIndex = (endGroup - 1) * this.activity.prizes.length;
            if (prizeKey) {
                for (let index in this.activity.prizes) {
                    if (this.activity.prizes[index].id == prizeKey) {
                        endIndex += parseInt(index);
                        this.trackConfig.prize = this.activity.prizes[index];
                    }
                }
            }
            this.trackConfig.endLeft = $('.track img').eq(endIndex).position().left - (prizeKey ? ($('.roll').width() / 2 - $('.track img').width() / 2) : 0);
        }
    }
}